import React, { useRef, useEffect } from 'react';
import { observer } from 'mobx-react';
import { ErrorNotificationVM, IErrorNotificationProps } from './ErrorNotificationVM';
import Icon from '@mdi/react';
import { mdiClose } from '@mdi/js';

const ErrorNotificationComponent = (props: IErrorNotificationProps) => {
  // Notification Ref functionality last existed on commit abe0fc9e0a2ed22fe6132b231770f4a74cf99c96 - 1/24/2025
  const notificationRef = useRef(null);
  const vm = useRef(new ErrorNotificationVM(props)).current;

  const { type = 'default', message = '', header, infoUrl, shortErrorCode, hidden = false, timestamp = undefined } = props;
  // Shows Notification when it receives a new hidden value
  useEffect(() => {
    vm.setHidden(hidden);
  }, [hidden, timestamp]);
  useEffect(() => {
    if (notificationRef.current !== null) {
      (notificationRef.current as any).focus();
    }
  }, [notificationRef.current])


  return (
    <div role="alert" aria-live="polite">
      <div className={`errornotification-container notification-${type}`}>
        <div className="row">
          <div className="col-2 notification-icon">
            <Icon
              data-testid="clear"
              path={vm.notifications[type].iconPath}
              title=""
              size={2}
              color={vm.notifications[type].iconColor}
            />
          </div>
          <div className="col-10">
            <section
              aria-label={`${type !== 'default' ? type : ''} ${shortErrorCode ? shortErrorCode : ''} ${message !== '' ? message : ''}`}
              className="notification"
              id='errornotification-details-id'
              tabIndex={0}
              ref={notificationRef}
            >
              <div className="notification-hd">
                {/* <button
                  className="usa-button usa-button--unstyled notification-close"
                  role="button"
                  title="Close Notification"
                  aria-label="Close Notification"
                  onClick={vm.clearNotification}
                >
                  <Icon path={mdiClose} title="" size={1} color={vm.notifications[type].iconColor} />
                </button> */}
                <h2 className="notification-title" id='notification-title'>
                  <strong>{header ? (header === 'INFORMATION!' ? vm.notifications[type].header : header) : vm.notifications[type].header}</strong>
                </h2>
              </div>
              <div className="notification-bd h5">
                {shortErrorCode ? <p id='notification-code'>
                  Code: {shortErrorCode}
                </p> : null}
                <p id='notification-message'>{message}</p>
                <p>{props.children}</p>

                {infoUrl !== undefined ? (
                  <a href={infoUrl} role="button" className="usa-button usa-button--outline" target="_blank">
                    More Details
                  </a>
                ) : null}
              </div>
            </section>
            <button
              className="usa-button usa-button--unstyled notification-close"
              role="button"
              title="Close Notification"
              aria-label="Close Notification"
              onClick={vm.clearNotification}
            >
              <Icon path={mdiClose} title="" size={1} color={vm.notifications[type].iconColor} />
            </button>
          </div>
        </div>
      </div>
      {/* </div> */}
    </div>
  );
};

export const ErrorNotification = observer(ErrorNotificationComponent);
